import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge } from 'react-bootstrap';
import { FaFilter } from 'react-icons/fa';

const TarifariosEmpresasFiltersButton = ({ onOpenFilters, activeFiltersCount = 0 }) => {
    return (
        <Button
            variant="outline-primary"
            onClick={onOpenFilters}
            className="me-2"
            style={{ position: 'relative' }}
        >
            <FaFilter className="me-2" />
            Filtros
            {activeFiltersCount > 0 && (
                <Badge
                    bg="danger"
                    pill
                    style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        fontSize: '0.75rem',
                        minWidth: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {activeFiltersCount}
                </Badge>
            )}
        </Button>
    );
};

TarifariosEmpresasFiltersButton.propTypes = {
    onOpenFilters: PropTypes.func.isRequired,
    activeFiltersCount: PropTypes.number
};

TarifariosEmpresasFiltersButton.defaultProps = {
    activeFiltersCount: 0
};

export default TarifariosEmpresasFiltersButton;
